import React from 'react';
import ReactDOM from 'react-dom';
import { Provider as ReduxProvider } from 'react-redux';
import { ApolloProvider } from '@apollo/client';
import { BrowserRouter as Router } from 'react-router-dom';
import store from './store';
import apolloClient from './lib/apolloClient';
import './index.css';
import App from './App';

ReactDOM.render(
  <ReduxProvider store={store}>
    <ApolloProvider client={apolloClient}>
      <Router>
        <App />
      </Router>
    </ApolloProvider>
  </ReduxProvider>,
  document.getElementById('root')
);
